import * as React from 'react';
const FilledStar = (props: any) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={12}
        height={12}
        fill="none"
        {...props}
    >
        <path
            fill="#444"
            d="M7.4 4.615 6 0 4.6 4.615H0L3.665 7.44 2.22 12 6 9.184 9.78 12 8.335 7.439 12 4.615H7.4Z"
        />
    </svg>
);
export default FilledStar;
